import { Badge, Box, Flex, Heading, Skeleton, Text } from '@radix-ui/themes';
import { PitchListAvatar } from 'components/common/pitch-lists/list-avatar';
import { PitcherHandBadge } from 'components/common/pitcher-hand-badge';
import { GameDataTeamLogo } from 'components/sections/game-data/team-logo';
import { RADIX } from 'lib_ts/enums/radix-ui';
import { IPitchList } from 'lib_ts/interfaces/pitches';

interface IProps {
  list: IPitchList;
  loading?: boolean;
}

export const PitchListAvatarHeader = (props: IProps) => {
  const { teamPk, team, name, hand, position, mlb_repertoire } = props.list;

  return (
    <Flex gap="3" align="center">
      <Skeleton loading={!!props.loading}>
        <Box>
          <PitchListAvatar
            list={props.list}
            size="7"
            fallbackColor={RADIX.COLOR.NEUTRAL}
          />
        </Box>
      </Skeleton>

      <Flex flexGrow="1" direction="column" gap="2">
        <Flex gap="2" align="center" wrap="wrap">
          <Skeleton loading={!!props.loading}>
            <Box minWidth="0">
              <Heading size="6">{name}</Heading>
            </Box>
          </Skeleton>
          <Flex gap={RADIX.FLEX.GAP.XS}>
            {hand && <PitcherHandBadge value={hand} />}
            {position && <Badge color={RADIX.COLOR.NEUTRAL}>{position}</Badge>}
          </Flex>
        </Flex>

        <Flex gap="2" align="center">
          {mlb_repertoire && teamPk && (
            <GameDataTeamLogo size="20px" teamPK={teamPk} name={team || ''} />
          )}

          {team && (
            <Skeleton loading={!!props.loading}>
              <Box minWidth="0">
                <Text color={RADIX.COLOR.SECONDARY} truncate>
                  {team}
                </Text>
              </Box>
            </Skeleton>
          )}
        </Flex>
      </Flex>
    </Flex>
  );
};
